import React from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import { color } from '../../../api/ColorsSector'
import { adress } from '../../../api/waterAdress'
import { formatWeight } from '../../../api/FormatWeight'
Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 70,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 30,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 8,
    marginVertical: 1,
    lineHeight: 1.2,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  tableColHeader: {
    padding: 2,
    borderStyle: 'solid',
    borderWidth: 0.3,
    borderColor: '#000',
    justifyContent: 'center', // по вертикали
  },

  tableTextCenter: {
    fontSize: 8,
    textAlign: 'center',
  },

  tableText: {
    fontSize: 8,
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
  tieNote: {
    fontSize: 6,
    color: '#666',
    textAlign: 'center',
  },
})
const WeighingTournamentProtocolPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  totalFishCount,
  totalWeight,
  averageFishWeight,
  biggestFish,
  isfinish,
}) => {
  const getname = (team) => {
    const sp1sports_category = team[0]?.sports_category
      ? ' (' + team[0]?.sports_category + ')'
      : ''
    const sp1 = team[0]?.fio ? team[0]?.fio : ''

    const sp2sports_category = team[1]?.sports_category
      ? ' (' + team[1]?.sports_category + ')'
      : ''
    const sp2 = team[1]?.fio ? ', ' + team[1]?.fio : ''

    const sp3sports_category = team[2]?.sports_category
      ? ' (' + team[2]?.sports_category + ')'
      : ''
    const sp3 = team[2]?.fio ? ', ' + team[2]?.fio : ''

    return (
      sp1 +
      sp1sports_category +
      sp2 +
      sp2sports_category +
      sp3 +
      sp3sports_category
    )
  }
  return (
    <Document style={{ margin: 40 }} scale={0.9}>
      <Page
        size="A4"
        style={{
          paddingBottom: 30,
          paddingRight: 20,
          paddingLeft: 20,
          paddingTop: 20,
          fontFamily: 'Roboto',
        }}
      >
        {/* Заголовок */}
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              Водоём:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {adress(tournament.water_id)
                  ? adress(tournament.water_id)
                  : tournament.water_body}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата проведения:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата составления:{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>

        <Text
          style={{
            fontSize: 12,

            textAlign: 'center',
            marginBottom: 1,
          }}
        >
          ИНФОРМАЦИОННЫЙ ПРОТОКОЛ ВЗВЕШИВАНИЯ
        </Text>
        {tournament.competition_format != 'Парные соревнования' ? (
          <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 5 }}>
            Ловля карпа - командные соревнования (мужчины, женщины), номер-код
            дисциплины 0920021811Л
          </Text>
        ) : (
          <></>
        )}

        <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 10 }}>
          Ловля карпа – парные соревнования (мужчины, женщины), код дисциплины
          0920151811Л
        </Text>
        <View>
          <View
            style={{
              width: '100%',
              borderStyle: 'solid',
              borderWidth: 0.3,
              borderColor: '#000',
            }}
          >
            <View
              style={{
                height: '20px',
                flexDirection: 'row',
                alignItems: 'stretch', // важно! , textAlign: 'left'
              }}
            >
              <View style={[styles.tableColHeader, { width: '6%' }]}>
                <Text style={styles.tableTextCenter}>Сектор</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '30%' }]}>
                <Text style={styles.tableText}>
                  Команда (пара), состав (Ф.И.О./разряд)
                </Text>
              </View>
              <View style={[styles.tableColHeader, { width: '7%' }]}>
                <Text style={styles.tableTextCenter}> Кол-во</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableTextCenter}>Вес</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '50%' }]}>
                <Text style={styles.tableText}> Список рыб</Text>
              </View>
            </View>
          </View>
        </View>
        {data.map((item, index) => (
          <View key={index} wrap={false}>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'stretch', // важно для одинаковой высоты 8FBC8F
                backgroundColor:
                  item.overallRank < 4
                    ? '#fff'
                    : item.totalWeight === 0
                      ? '#fff'
                      : '#fff',
              }}
            >
              <View style={[styles.tableColHeader, { width: '6%' }]}>
                <Text style={[styles.tableText, { textAlign: 'left' }]}>
                  <Text style={styles.tableTextCenter}> {item.sector}</Text>
                </Text>
              </View>

              <View
                style={[
                  styles.tableColHeader,
                  { width: '30%', alignItems: 'flex-start' },
                ]}
              >
                <Text style={[styles.tableText, { textAlign: 'left' }]}>
                  <Text style={{ fontWeight: 'bold' }}>{item.teamName}</Text>
                  {'\n'}
                  <Text>{item.sp}</Text>
                </Text>
              </View>

              <View style={[styles.tableColHeader, { width: '7%' }]}>
                <Text style={[styles.tableText]}>
                  <Text style={styles.tableTextCenter}>
                    {formatWeight(item.fishCount)}
                  </Text>
                </Text>
              </View>

              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={[styles.tableText]}>
                  <Text style={styles.tableTextCenter}>
                    {' '}
                    {formatWeight(item.totalWeight)}
                  </Text>
                </Text>
              </View>
              <View
                style={[
                  styles.tableColHeader,
                  { width: '50%', alignItems: 'flex-start' },
                ]}
              >
                <Text style={[styles.tableText]}>
                  <Text style={{ alignItems: 'flex-start' }}>
                    {' '}
                    {item.fishList.join(', ')}
                  </Text>
                </Text>
              </View>
            </View>
          </View>
        ))}

        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 40,
          }}
        >
          <View
            style={{
              width: '45%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
                textAlign: 'center',
              }}
            >
              {administrator[0]?.surname +
                ' ' +
                administrator[0]?.name +
                ' ' +
                administrator[0]?.patronymic +
                ' (' +
                administrator[0]?.role +
                ', ' +
                administrator[0]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '45%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
                textAlign: 'center',
              }}
            >
              {administrator[1]?.surname +
                ' ' +
                administrator[1]?.name +
                ' ' +
                administrator[1]?.patronymic +
                ' (' +
                administrator[1]?.role +
                ', ' +
                administrator[1]?.rank +
                ') '}
            </Text>
          </View>
        </View>

        {/* Логотипы партнеров */}
        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default WeighingTournamentProtocolPDF
